import { plannedTrip, tripPlanning, version } from "@/utils/constants";
import { handleResponse, handleError } from "@/utils/functions";

export default (axios) => ({
  getTripPlanningOptions(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.options}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanningList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanningDetails(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}${id}/view/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanningEvents(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}${id}/events/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deleteTripPlanningObject(planId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${tripPlanning.base}${planId}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createTripPlanningObject(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${tripPlanning.base}`, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateTripPlanningObject(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(`${tripPlanning.base}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateTripPlanningObject(id, payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${tripPlanning.base}${id}/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanOrderList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}planning_orders/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanDriverList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}planning_drivers/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  deletePlannedTrip(tripId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`${plannedTrip.base}${tripId}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getTripPlanInfo(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}${id}/summary/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  createSingleTrip(tripId, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${plannedTrip.base}${tripId}/create_trip/`, payload)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getDownloadFile(planId, url) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}${planId}/${url}/`, {
          responseType: "blob",
          headers: { accept: "application/xlsx" },
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getPlannedTripList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${plannedTrip.base}`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getPlanTripRouteData(trip_id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${plannedTrip.base}${trip_id}/planned_trip_route/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getAllOrderData(plan_id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${tripPlanning.base}${plan_id}/order_coordinates/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getUnplannedDriverList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${version}planned_performer/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getUnplannedOrderListList(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${version}planned_order/`, { params: params })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  retryTripPlan(id) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`${tripPlanning.base}${id}/retry_plan/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
